module.exports = __webpack_public_path__ + "img/banner.81075fbf.png";